<template>
  <div class="info">
    <div class="info__title">{{ live.name }}</div>
    <div class="info__author" v-if="live.user">
      <span class="info__author__role">Especialista</span> 
      <span class="info__author__name">{{ live.user.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    live: { type: Object, required: true }
  }
}
</script>

<style lang="scss" scoped>
  .info {
    padding: 32px 16px;
    font-family: Poppins;
    letter-spacing: 0.2px;

    &__title {
      font-size: 20px;
      font-weight: 700;
    }
    
    &__author {
      font-size: 15px;

      &__role {
        text-transform: uppercase;
        font-weight: 600;
        color: #000;

        &:after {
          content: '|';
          font-weight: 400;
          padding: 0 10px;
        }
      }
    }
  }
</style>